import React from "react";
import PropTypes from "prop-types";
import { CrisisBanner } from "Components/CrisisBanner";
import MapBlocksToComponents from "Helpers/BlockHelper";
import { StartPagePuffs } from "Blocks";
import { PageTransition } from "Animations";
import { PageHeader, Line } from "BaseComponents/Text/";
import { StandardImage, StandardImageWrapper, Img } from "Components/StandardImage";

let StartPage = ({ Heading, ElementArea, StartpagePuffs, PublicAnnouncement, Image }) => {
	return (
		<>
			<PageHeader marginBottom="0" display={Image ? "none" : "flex"} Heading={Heading} />
			{Image && (
				<StandardImageWrapper>
					<Img maxWidth="350px" src={Image} /> <Line />
				</StandardImageWrapper>
			)}

			{PublicAnnouncement != undefined && <CrisisBanner {...PublicAnnouncement} />}

			<StartPagePuffs model={StartpagePuffs} />
			<PageTransition transitionDuration="500" delay="400">
				{ElementArea.length > 0 && MapBlocksToComponents(ElementArea)}
			</PageTransition>
		</>
	);
};

StartPage.propTypes = {
	Heading: PropTypes.string,
	Image: PropTypes.object,
	ElementArea: PropTypes.array,
	StartpagePuffs: PropTypes.array,
	Ingress: PropTypes.string,
};

export default StartPage;
